/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { SubscriptionContactsPagedList } from '../../models/subscription-contacts-paged-list';

export interface SearchSubscriptionContacts$Any$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * EMAIL : the mail
 *   * FIRST_NAME
 *   * LAST_NAME
 */
  sortFieldName?: 'EMAIL' | 'FIRST_NAME' | 'LAST_NAME';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search contacts
     */
    body?: any
}

export function searchSubscriptionContacts$Any(http: HttpClient, rootUrl: string, params: SearchSubscriptionContacts$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionContactsPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchSubscriptionContacts$Any.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionContactsPagedList>;
    })
  );
}

searchSubscriptionContacts$Any.PATH = '/custom/subscriptions/{uid}/contacts/search';
